import React from 'react';
import './questionControls.scss'; 
import { useIsMobile } from '../../hooks/isMobile';

const QuestionControls = ({
  onMarkForReview,
  onClearResponse,
  onSaveAndNext,
}) => {
  const isMobile = useIsMobile();

  return (
    <div className="question-controls-wrapper">
      <div className={`question-controls-container ${isMobile ? 'mobile' : ''}`}>
        <div className={`button-group ${isMobile ? 'mobile' : ''}`}>
          <button className="secondary-button" >
            Mark for Review & Next
          </button>
          <button className="secondary-button" >
            Clear Response
          </button>
        </div>
        <button className="primary-button" >
          Save & Next
        </button>
      </div>
    </div>
  );
};

export default QuestionControls;
